import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'

import { size } from '@twisto/styles'

export const root = (theme: Theme) => css`
  margin-top: ${size[4]};
  color: ${theme.palette.neutral[700]};
`

export const error = (theme: Theme) => css`
  color: ${theme.palette.error[500]};
`

export const disabled = (theme: Theme) => css`
  color: ${theme.palette.neutral[600]};
`
